import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { APIEndpointWeb, webapi } from "@client/web";
import {
  CK_SHARED_TOKEN,
  CK_ACCESS_TOKEN,
  CK_ACCESS_DATA_ROLE,
  CK_TYPE,
} from "@constant/constant";
import R from "@routers/R";
import {
  Col,
  Row,
  Typography,
  notification,
  Menu,
  Button,
  Space,
  Layout,
  Dropdown,
  Avatar,
  Card,
  Modal,
  Image,
  Divider,
} from "antd";
import { Content, Header } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useState } from "react";
import { Cookies, useCookies } from "react-cookie";
import { Redirect, useHistory, useRouteMatch } from "react-router-dom";
import logo1 from "../../src/Image/logoFmr.png";

const { Text } = Typography;

export interface userDisplay {
  insurer: string;
  name: string;
  ref_code: string;
}

const MedicalLayout: React.FC = (props): JSX.Element => {
  const [resUserDisplay, setResUserDisplay] = useState<userDisplay>();
  const [WindowResize, setWindowResize] = useState(Number);
  const [goToPath, setGoToPath] = useState("");
  const { children } = props;
  const history = useHistory();
  const route = useRouteMatch();
  const getCookies = new Cookies();
  const [cookies, setCookie, removeCookie] = useCookies([
    CK_SHARED_TOKEN,
    CK_ACCESS_TOKEN,
    CK_ACCESS_DATA_ROLE,
    CK_TYPE
  ]);

  const handleGoToPath = (path: string): void => {
    setGoToPath(path);
  };

  useEffect(() => {
    if (cookies.type !== 'med') {
      history.push('/')
    }
    checkCookie();
    getuserdisplay();
    // const interval = setInterval(() => {
    //   checkCookie();
    // }, 1500);
    // return () => clearInterval(interval);
  }, [route]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    handleWindowResize();
  }, [WindowResize]);

  const handleWindowResize = () => {
    setWindowResize(window.innerWidth);
  };

  const getuserdisplay = async () => {
    if (cookies.shared_token) {
      const { data } = await webapi.get(`${APIEndpointWeb.GetUserDisplay}`, {
        withCredentials: true,
        // headers: { Authorization: `Bearer ${cookies.shared_token}` },
      });
      setResUserDisplay(data.result);
    } else if (!cookies.shared_token) {
      history.replace("/login");
    }
    else {
      console.log('err');
    }
  };

  const checkCookie = () => {
    var role = getCookies.get("role");
    var shared_token = getCookies.get("shared_token");
    if (!(Object.keys(cookies).length === 0 && cookies.constructor === Object) && role === "Med" && shared_token) {
    } else {
      history.replace("/");
    }
  };

  const checkpathname = () => {
    switch (window.location.pathname) {
      case "/medical-pending":
        return "ประวัติการรักษาที่รอการยืนยัน";
      case "/consent-success":
        return "ประวัติการรักษาที่ยืนยันสำเร็จ";
      default:
        return "ประวัติการรักษาที่รอการยืนยัน";
    }
  };
  const checkpathnameweb = () => {
    switch (window.location.pathname) {
      case "/medical-pendingweb":
        return "ประวัติการรักษาที่รอการยืนยัน";
      case "/medical-success-web":
        return "ประวัติการรักษาที่ยืนยันสำเร็จ";
      default:
        return "ประวัติการรักษาที่รอการยืนยัน";
    }
  };

  function handleMenuClick() {
    webapi.post(`${APIEndpointWeb.logout}`,
        {
          withCredentials: true,
        }
    ).then(() => {

    }).catch ((error) => {
      console.log(error.response);
    })
    history.replace("/login");
    window.location.reload();
  }

  const showConfirm = (): any => {
    Modal.confirm({
      title: "คุณต้องการออกจากระบบใช่หรือไม่",
      // content: 'ลงชื่อออก',
      okText: "ตกลง",
      cancelText: "ยกเลิก",
      okButtonProps: {
        type: "primary",
      },
      cancelButtonProps: {
        type: "default",
      },
      onOk() {
        setTimeout(() => {
          handleMenuClick();
        }, 1000);
      },
      onCancel() {
        // console.log('can');
      },
    });
  };

  const menu = (
    <Row
      className="mr-4"
      justify="center"
      style={{
        borderRadius: "20px",
        backgroundColor: "#B6D3D6",
        width: "35vh",
      }}
    >
      <Col
        className="pl-2 pr-2"
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        xxl={24}
      >
        <Card
          style={{
            backgroundColor: "#26334A",
            borderRadius: "20px 20px 0px 0px",
          }}
        >
          <Row style={{ textAlign: "center" }}>
            <Col xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <Avatar size="large" icon={<UserOutlined />} />
            </Col>
            <Col
              xs={18}
              sm={18}
              md={18}
              lg={18}
              xl={18}
              xxl={18}
              className="mt-2"
            >
              <Text style={{ color: "#ffffff", fontSize: "16px" }}>
                {resUserDisplay?.name}
              </Text>
            </Col>
          </Row>
        </Card>
        <Row>
          <Col
            className="pl-2 pr-2"
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            xxl={24}
            style={{
              backgroundColor: "#26334A",
              borderRadius: "0px 0px 20px 20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Text
              className="mt-2 mb-2"
              style={{ color: "#ffffff", fontSize: "14px" }}
            >
              {resUserDisplay?.insurer}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col className="p-2" xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Button
              block
              type="text"
              style={{ backgroundColor: "#B6D3D6" }}
              onClick={showConfirm}
            >
              <Space direction="horizontal">
                <LogoutOutlined
                  twoToneColor="#26334A"
                  style={{ fontSize: "22px" }}
                />
                <Text style={{ color: "26334A", fontSize: "17px" }}>
                  ออกจากระบบ
                </Text>
              </Space>
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );

  return (
    <>
      {goToPath ? <Redirect to={goToPath} /> : null}
      {WindowResize < 1024 && (
        <Content>
          <Row className="layout-100" justify="center">
            <Col xs={24} sm={24} md={24} lg={10} xl={10} xxl={10}>
              <Row
                className="font-header"
                style={{ backgroundColor: "#147F8B", textAlign: "center" }}
              >
                <Col
                  className="pt-5"
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                >
                  <Text style={{ color: "white" }}>{checkpathname()}</Text>
                  <Row className="mt-3 ">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <Menu
                        className="p-3 font-menu"
                        //mode="horizontal"
                        style={{
                          justifyContent: "space-between",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "20px 20px 0px 0px",
                        }}
                      >
                        <Menu.Item
                          onClick={(): void => {
                            handleGoToPath(R.HomeRouter.medpending.link);
                          }}
                          key="1"
                          style={{ color: "black" }}
                        >
                          {window.location.pathname === "/medical-pending" ? (
                            <Text style={{ color: "#147F8B" }}>
                              {" "}
                              ประวัติรอการยืนยัน{" "}
                            </Text>
                          ) : (
                            "ประวัติรอการยืนยัน"
                          )}
                        </Menu.Item>
                        <Menu.Item
                          onClick={(): void => {
                            handleGoToPath(R.HomeRouter.consentsuccess.link);
                          }}
                          key="2"
                          style={{ color: "black" }}
                        >
                          {window.location.pathname === "/consent-success" ? (
                            <Text style={{ color: "#147F8B" }}>
                              {" "}
                              ประวัติยืนยันสำเร็จ{" "}
                            </Text>
                          ) : (
                            " ประวัติยืนยันสำเร็จ"
                          )}
                        </Menu.Item>
                      </Menu>
                      <Divider
                        style={{
                          marginBottom: 0,
                          marginTop: 0,
                          maxWidth: "auto",
                        }}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              {children}
            </Col>
          </Row>
        </Content>
      )}

      {WindowResize >= 1024 && (
        <Layout style={{ minHeight: "100vh" }}>
          <Sider
            style={{
              backgroundColor: "#4EA5B2",
              boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
              height: "100%",
              position: "fixed",
              left: 0,
              zIndex: 99,
            }}
            width={280}
          >
            <Row>
              <Col
                className="pt-4 pr-3 pl-3 pb-5"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                <Space
                  direction="vertical"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Image
                    preview={false}
                    src={logo1}
                    width="200px"
                    height="70px"
                  />
                </Space>
              </Col>
            </Row>
            {/* ปุ่มเมนู1 */}
            <Row>
              <Col
                className="p-3"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                {window.location.pathname === "/medical-pendingweb" ? (
                  <Button
                    block
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.medpendingweb.link);
                    }}
                    key="2"
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#ffffff",
                      border: "none",
                    }}
                  >
                    <Text style={{ color: "#056839" }}>ประวัติรอการยืนยัน</Text>
                  </Button>
                ) : (
                  <Button
                    block
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.medpendingweb.link);
                    }}
                    key="2"
                    style={{
                      borderRadius: "20px",

                      backgroundColor: "#005A67",
                      border: "none",
                    }}
                  >
                    <Text style={{ color: "#ffffff" }}>ประวัติรอการยืนยัน</Text>
                  </Button>
                )}
              </Col>
            </Row>

            {/* ปุ่มเมนู2 */}
            <Row>
              <Col
                className="p-3"
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={24}
              >
                {window.location.pathname === "/medical-success-web" ? (
                  <Button
                    block
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.medsuccessweb.link);
                    }}
                    key="2"
                    style={{
                      borderRadius: "20px",
                      backgroundColor: "#ffffff",
                      border: "none",
                    }}
                  >
                    <Text style={{ color: "#056839" }}>
                      ประวัติยืนยันสำเร็จ
                    </Text>
                  </Button>
                ) : (
                  <Button
                    block
                    size="large"
                    onClick={(): void => {
                      handleGoToPath(R.HomeRouter.medsuccessweb.link);
                    }}
                    key="2"
                    style={{
                      borderRadius: "20px",

                      backgroundColor: "#005A67",
                      border: "none",
                    }}
                  >
                    <Text style={{ color: "#ffffff" }}>
                      ประวัติยืนยันสำเร็จ
                    </Text>
                  </Button>
                )}
              </Col>
            </Row>
          </Sider>
          <Layout>
            <Header
              style={{
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
                position: "fixed",
                zIndex: 1,
                top: 0,
                left: 280,
                right: 0,
                height: "80px",
              }}
            >
              <Row justify="space-between">
                <div
                  className="ml-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80px",
                  }}
                >
                  <Text
                    style={{
                      color: " #147F8B",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    {" "}
                    {checkpathname()}
                  </Text>
                </div>
                <div
                  className="mr-4"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80px",
                  }}
                >
                  <Space size={40}>
                    <Space
                      direction="vertical"
                      className="space-gap"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: "#147F8B",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        {resUserDisplay?.insurer}
                      </Text>

                      <Text
                        className="font-description"
                        style={{ color: "#147F8B", fontSize: "14px" }}
                      >
                        {resUserDisplay?.name}
                      </Text>
                    </Space>
                    <Text style={{ color: " #147F8B", fontSize: "28px" }}>
                      {" "}
                      |
                    </Text>
                    <Dropdown
                      overlay={menu}
                      overlayStyle={{ paddingTop: "25px" }}
                      placement="bottomCenter"
                    >
                      {/* <CaretDownOutlined style={{ fontSize: "24px" }} /> */}
                      <Avatar
                        style={{ cursor: "pointer" }}
                        size="large"
                        icon={<UserOutlined />}
                      />
                    </Dropdown>
                  </Space>
                </div>
              </Row>
            </Header>
            <Content className="mt-5 ml-5">{children}</Content>
          </Layout>
        </Layout>
      )}
    </>
  );
};

export default MedicalLayout;
